import { IRecording } from '../../appointments/recording/RecordingState';
import { WaveformLinesIcon } from '../../theme/Icons';
import { AITranscription } from '../generic-notes/AITranscription';
import { ViewNoteSection } from './ViewNoteSection';

export const Transcription: React.FC<{note: any}> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;
    return recording?.transcription && (
        <ViewNoteSection title="Transcription" Icon={WaveformLinesIcon} showAIIcon>
            <AITranscription recording={recording} />
        </ViewNoteSection>
    );

};
